import { z } from 'zod';
/**
 * Сроки доступа.
 *
 * Числами дней, а не именами вроде `month`: цену и набор сроков правят из
 * админки, и «месяц» пришлось бы объяснять отдельно и на сервере, и на экране.
 */
export const VPN_TERM_DAYS = [7, 30, 90];
export const vpnTermDaysSchema = z.union([z.literal(7), z.literal(30), z.literal(90)]);
export const vpnPurchaseSchema = z.object({ days: vpnTermDaysSchema }).strict();
export const vpnAutoRenewSchema = z.object({ enabled: z.boolean() }).strict();
/** Настройки раздела: цены и предел устройств правятся из админки. */
export const adminVpnSettingsSchema = z
    .object({
    enabled: z.boolean(),
    deviceLimit: z.number().int().min(0).max(100),
    /**
     * Строка в карточке подписки Happ и INCY (заголовок announce). Пусто — общая
     * подсказка о продлении. Happ показывает до 200 знаков.
     */
    announce: z.string().trim().max(200).optional(),
    /**
     * Прежнее «название узла». Профили давно подписывает сама панель, поле ни на что
     * не влияет; принимается, чтобы старая админка в кэше не получала отказ.
     */
    nodeLabel: z.string().max(40).optional(),
    /** Сколько гигабайт в месяц. 0 — без ограничения, и полоса расхода не показывается. */
    trafficGb: z.number().int().min(0).max(100_000),
    terms: z
        .array(z
        .object({
        days: vpnTermDaysSchema,
        stars: z.number().int().min(1).max(1_000_000)
    })
        .strict())
        .length(VPN_TERM_DAYS.length)
})
    .strict();
//# sourceMappingURL=vpn.js.map